<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-chat-history-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">Atlas Chat History · {{ data?.preferredUsername || '-' }}</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body chat-history-dialog">
        <div class="modal-body">
          <div class="history-shell">
            <div class="history-list">
              <div class="history-search">
                <input
                  class="history-search-input"
                  type="text"
                  [ngModel]="searchTerm"
                  (ngModelChange)="onSearchTermChange($event)"
                  placeholder="Search sessions..."
                />
              </div>
              <div
                *ngFor="let session of filteredSessions; let idx = index"
                class="history-session-row"
              >
                <button
                  class="history-session"
                  [class.history-session-active]="isSelectedSession(session, idx)"
                  [class.history-session-current]="session.isCurrent"
                  type="button"
                  (click)="selectSession(idx)"
                >
                  <div class="history-session-time">{{ formatSessionListTimestamp(session) }}</div>
                  <div class="history-session-ref">
                    <span [innerHTML]="getHighlightedPlainText('Case: ' + getCaseNumberText(session)) | safeHtml"></span>
                    <span
                      class="history-session-score-dot"
                      [class.history-session-score-dot-0]="getSessionScore(session) === 0"
                      [class.history-session-score-dot-1]="getSessionScore(session) === 1"
                      [class.history-session-score-dot-2]="getSessionScore(session) === 2"
                      [class.history-session-score-dot-3]="getSessionScore(session) === 3"
                      [class.history-session-score-dot-4]="getSessionScore(session) === 4"
                      [class.history-session-score-dot-5]="getSessionScore(session) === 5"
                      [title]="getSessionScoreText(session)"
                      [attr.aria-label]="'Session score: ' + getSessionScoreText(session)"
                    ></span>
                  </div>
                  <div class="history-session-description" *ngIf="session.sessionDescription">
                    <span [innerHTML]="getHighlightedPlainText(session.sessionDescription) | safeHtml"></span>
                  </div>
                </button>
                <button
                  *ngIf="!session.isCurrent"
                  class="history-session-delete"
                  type="button"
                  title="Remove chat"
                  aria-label="Remove chat"
                  (click)="removeSession(session, $event)"
                >
                  <img src="/assets/icons/remove.svg" alt="" />
                </button>
              </div>
              <div *ngIf="!data?.sessions?.length" class="history-empty">
                No chat sessions yet.
              </div>
              <div *ngIf="data?.sessions?.length && !filteredSessions.length" class="history-empty">
                No sessions match your search.
              </div>
              <div *ngIf="data?.sessions?.length && !searchTerm.trim()" class="history-load-more">
                <button
                  *ngIf="data?.hasMoreSessions"
                  class="history-load-more-button"
                  type="button"
                  [disabled]="data?.isLoadingMoreSessions"
                  (click)="loadMore()"
                >
                  {{ data?.isLoadingMoreSessions ? 'Loading...' : 'Load 10 more' }}
                </button>
                <div *ngIf="!data?.hasMoreSessions" class="history-load-more-text">
                  All loaded sessions are shown.
                </div>
              </div>
            </div>

            <div class="history-view" *ngIf="selectedSession as session">
              <div class="history-meta">
                <div class="history-meta-actions">
                  <div class="history-meta-action-text">
                    Preview conversation before continuing it in Atlas.
                  </div>
                  <button
                    class="history-continue-button"
                    type="button"
                    (click)="continueSelectedSession()"
                  >
                    {{ getContinueButtonText(session) }}
                  </button>
                </div>
                <div class="history-meta-line">
                  <strong>Session ID: </strong>
                  <span [innerHTML]="getHighlightedPlainText(session.sessionId || '-') | safeHtml"></span>
                </div>
                <div class="history-meta-line">
                  <strong>Description: </strong>
                  <button
                    *ngIf="!isEditingDescription"
                    class="history-description-edit-trigger"
                    type="button"
                    [attr.title]="session.sessionDescription || 'Click to edit description'"
                    (click)="beginEditSelectedSessionDescription()"
                  >
                    <span [innerHTML]="getHighlightedPlainText(session.sessionDescription || '-') | safeHtml"></span>
                  </button>
                  <input
                    *ngIf="isEditingDescription"
                    class="history-description-input"
                    type="text"
                    [(ngModel)]="descriptionDraft"
                    (keydown.enter)="saveSelectedSessionDescription()"
                    (blur)="saveSelectedSessionDescription()"
                    placeholder="Add description"
                  />
                </div>
                <div class="history-meta-line">
                  <strong>Case number: </strong>
                  <span [innerHTML]="getHighlightedPlainText(getCaseNumberText(session)) | safeHtml"></span>
                </div>
                <div class="history-meta-line history-score-line">
                  <strong>Overall score:</strong>
                  <div class="history-score-picker" role="group" aria-label="Set overall chat score">
                    <button
                      *ngFor="let option of scoreOptions"
                      type="button"
                      class="history-score-dot"
                      [class.history-score-dot-active]="getSessionScore(session) === option.score"
                      [class.history-score-dot-1]="option.score === 1"
                      [class.history-score-dot-2]="option.score === 2"
                      [class.history-score-dot-3]="option.score === 3"
                      [class.history-score-dot-4]="option.score === 4"
                      [class.history-score-dot-5]="option.score === 5"
                      [attr.aria-label]="'Set score to ' + option.score + ' - ' + option.label"
                      [title]="option.score + ' - ' + option.label"
                      (click)="setSelectedSessionScore(option.score)"
                    ></button>
                  </div>
                  <span class="history-score-text">{{ getSessionScoreText(session) }}</span>
                </div>
              </div>

              <div
                #historyMessages
                class="history-messages"
                tabindex="0"
                (keydown)="onMessageAreaKeydown($event, historyMessages)"
              >
                <div
                  *ngFor="let message of session.messages"
                  class="message-row"
                  [class.message-row-user]="message.author === 'user'"
                >
                  <div class="message-block">
                    <div *ngIf="formatMessageTimestamp(message.timestamp)" class="message-timestamp">
                      {{ formatMessageTimestamp(message.timestamp) }}
                    </div>
                    <div class="message-bubble" [class.message-bubble-user]="message.author === 'user'">
                      <ng-container *ngIf="message.author === 'bot'; else plainHistoryMessage">
                        <div [innerHTML]="getHighlightedMessageHtml(message) | safeHtml"></div>
                      </ng-container>
                      <ng-template #plainHistoryMessage>
                        <div [innerHTML]="getHighlightedPlainText(message.text) | safeHtml"></div>
                      </ng-template>
                    </div>

                    <div *ngIf="message.author === 'user'" class="message-context-indicator">
                      <span class="message-context-badge" [class.message-context-badge-on]="message.caseContextModeEnabled" [class.message-context-badge-off]="!message.caseContextModeEnabled">
                        <ng-container *ngIf="message.caseContextModeEnabled; else historyContextOff">
                          <span [innerHTML]="getHighlightedPlainText('Case context On') | safeHtml"></span>
                        </ng-container>
                        <ng-template #historyContextOff>Case context Off</ng-template>
                      </span>
                    </div>
                    <div *ngIf="message.author === 'user' && message.caseContextModeEnabled" class="history-message-fields">
                      <span [innerHTML]="getHighlightedPlainText(getEnabledFieldsText(message)) | safeHtml"></span>
                    </div>

                    <div *ngIf="message.author === 'bot'" class="history-feedback">
                      <span [innerHTML]="getHighlightedPlainText(getFeedbackSummary(message)) | safeHtml"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="history-view history-view-empty" *ngIf="!selectedSession">
              Select a session to view chat history.
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="pendingRemoveSession" class="history-remove-confirm-backdrop">
        <div class="history-remove-confirm" role="dialog" aria-modal="true" aria-labelledby="historyRemoveConfirmTitle">
          <div class="history-remove-confirm-header">
            <div id="historyRemoveConfirmTitle" class="history-remove-confirm-title">Remove chat</div>
            <button
              class="history-remove-confirm-close"
              type="button"
              aria-label="Cancel remove"
              (click)="cancelRemoveSession()"
            >
              <img src="/assets/icons/Close White.svg" alt="" />
            </button>
          </div>
          <div class="history-remove-confirm-body">
            Are you sure you want to remove the chat?
          </div>
          <div class="history-remove-confirm-footer">
            <button class="history-remove-cancel-button" type="button" (click)="cancelRemoveSession()">Cancel</button>
            <button class="history-remove-confirm-button" type="button" (click)="confirmRemoveSession()">Remove</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
